import React from 'react';
import styled from 'styled-components';

import { formatNumber } from 'modules/health/helpers/formatNumber';

type MembersCountProps = {
  teamMembersCount: number;
};

const MembersCount = ({ teamMembersCount }: MembersCountProps) => {
  const label = teamMembersCount === 1 ? 'team member' : 'team members';

  return (
    <MembersCountWrapper>
      <CountWrapper>{formatNumber(teamMembersCount)}</CountWrapper>{' '}
      <TextWrapper>{label}</TextWrapper>
    </MembersCountWrapper>
  );
};

const MembersCountWrapper = styled.div`
  position: absolute;
  top: 32px;
  left: 39px;
`;

const CountWrapper = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 50px;
  color: ${({ theme }) => theme.colors.white};
`;

const TextWrapper = styled.span`
  font-size: 16px;
  line-height: 50px;
  color: ${({ theme }) => theme.colors.white};
`;

export default MembersCount;
